import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ssDispatch } from '~SpectateStore';
import { inplayEventData } from '~SpectateStore/thunks/inplayEventData';
import { eventDataCleanUp } from '~SpectateStore/actions/eventDataCleanUp';
import { useEventHasMarkets } from '~SpectateStore/hooks/marketsHooks';
import { useHasScoreboard } from '~SpectateStore/hooks/scoreboardHooks';
import { useSportSlugByEventId } from '~SpectateStore/hooks/sportsHooks';
import NoMarkets from '~spa/Pages/ErrorPages/NoMarkets/NoMarkets';
import mainSocket from '~shared/services/mainSocketClass';
import { getGaAttributeObjectInplayEventPage } from '~shared/utils/google-analytics';
import { inplayWSHandler } from './handlers/wsHandler';
import MarketsSection from './Components/MarketsSection';
import MoreGamesEventsSection from './Components/MoreGamesEventsSection';
import MarketsGroupTabs from './Components/MarketsGroupTabs';
import ScoreboardSection from './Scoreboard/ScoreboardSection';

const InplayEventPage = ({ match: { params: { eventId }}}) => {
    const [ t ] = useTranslation();
    const [ isLoading, setIsLoading ] = useState(true);
    const wsHandlerRef = useRef(Object.getPrototypeOf(Function));
    const eventHasMarkets = useEventHasMarkets(eventId);
    const hasScoreboard = useHasScoreboard(eventId);
    const sportSlug = useSportSlugByEventId(eventId);

    useEffect(() => {
        setIsLoading(true);
        ssDispatch(inplayEventData(eventId)).finally(() => {
            setIsLoading(false);
            mainSocket.subscribeForUpdates([{ event_id: Number(eventId) }], `event_${eventId}_inplay_data`);
            wsHandlerRef.current = mainSocket.onWsEventUpdate(msg => inplayWSHandler(msg, eventId));
        });

        return () => {
            ssDispatch(eventDataCleanUp(eventId));
            mainSocket.unsubscribeForUpdates([{ event_id: Number(eventId) }]);
            wsHandlerRef.current();
        };
    }, [eventId]);

    if (isLoading) {
        return null;
    }

    if (!isLoading && !eventHasMarkets && !hasScoreboard) {
        return <NoMarkets />;
    }

    return (
        <div className='inplay-event-page' {...getGaAttributeObjectInplayEventPage(sportSlug)}>
            <MoreGamesEventsSection
                eventId={eventId}
            />
            <ScoreboardSection
                eventId={eventId}
            />
            <MarketsGroupTabs
                eventId={eventId}
            />
            <MarketsSection
                eventId={eventId}
            />
            <div className="inplay-event-page__disclaimer">
                {t('sport_event.disclaimer')}
            </div>
        </div>
    );
};

InplayEventPage.propTypes = {
    match: PropTypes.object.isRequired,
};

export default InplayEventPage;
